import { render, staticRenderFns } from "./Att.vue?vue&type=template&id=5512b3ce&scoped=true&"
import script from "./Att.vue?vue&type=script&lang=js&"
export * from "./Att.vue?vue&type=script&lang=js&"
import style0 from "./Att.vue?vue&type=style&index=0&id=5512b3ce&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5512b3ce",
  null
  
)

export default component.exports